import useLastDateForCustodianData from "./useLastDateForCustodianData";
import usePerformanceGroupSummaryV4 from "./usePerformanceGroupSummaryV4";
export default function useManagedAccountCustodiansV4(groupId, timeFrame, customTimeFrame, clientId, authConfig) {
    const lastDate = useLastDateForCustodianData(clientId, authConfig).data ?? new Date();
    return usePerformanceGroupSummaryV4(groupId, timeFrame, customTimeFrame, clientId, authConfig, lastDate);
}
//# sourceMappingURL=useManagedAccountCustodiansV4.js.map